import { AdjustmentTypePolicy } from "constants/charge/AdjustmentTypePolicy";
import { CounterCustomerChargeEntity } from "domain/entity/CounterCustomerCharge/CounterCustomerChargeEntity";
import _ from "lodash";
import { CounterCustomerChargeMaintenanceConstant } from "presentation/constant/CounterCustomerCharge/CounterCustomerChargeMaintenanceConstant";
import { useCounterCustomerChargeMaintenanceVM } from "presentation/hook/CounterCustomerCharge/useCounterCustomerChargeMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useCounterCustomerChargeMaintenanceTracked } from "presentation/store/CounterCustomerCharge/CounterCustomerChargeMaintenanceProvider";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useCallback, useMemo, useState } from "react";
import { FieldType, HPHButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, Sidebarheader } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const AdjustmentPanel = () => {
    const [counterCustomerChargeState] = useCounterCustomerChargeMaintenanceTracked();
    const counterCustomerChargeVM = useCounterCustomerChargeMaintenanceVM();
    const COUNTER_CUSTOMER_CHARGE_CONSTANT = CounterCustomerChargeMaintenanceConstant.Detail;
    const { editingEntity, allFormState } = counterCustomerChargeState;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const messageBarVM = useMessageBarVM();

    const handleSaveClick = useCallback(async () => {
        if (_.isEmpty(counterCustomerChargeState.selectedRows)) {
            messageBarVM.showError('Please select record(s).');
            return;
        }
        setIsLoading(true);
        let entityList: CounterCustomerChargeEntity[] = [];
        counterCustomerChargeState.selectedRows.forEach(item => {
            item.adjustmentType = editingEntity?.adjustmentType;
            if (editingEntity?.adjustmentType && editingEntity?.adjustmentType === AdjustmentTypePolicy.TEXT_CANCEL) {
                item.adjustmentType = AdjustmentTypePolicy.ADJ_TYPE_CANCEL
            }
            if (editingEntity?.adjustmentType && editingEntity?.adjustmentType === AdjustmentTypePolicy.TEXT_CANCEL_REBILL) {
                item.adjustmentType = AdjustmentTypePolicy.ADJ_TYPE_CANCEL_REBILL
            }
            entityList.push(item);
        });
        await counterCustomerChargeVM.onValidationAdjustmentType(entityList[0]).then(data => {
            if (data) {
                counterCustomerChargeVM.onAdjustment(entityList).then(async (res) => {
                    setIsLoading(false);
                    if (res && res.success) {
                        if (res.data) {
                            messageBarVM.showError(res.data);
                        } else {
                            messageBarVM.showSuccess("Adjustment Successfully.");
                        }
                        counterCustomerChargeVM.onMoreClose();
                        await counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
                    } else {
                        messageBarVM.showError("Adjustment Failed.");
                        counterCustomerChargeVM.onMoreClose();
                        await counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
                    }
                });
            } else {
                setIsLoading(false);
            }
        })

    }, [counterCustomerChargeVM, counterCustomerChargeState.selectedRows, counterCustomerChargeState.searchCriteria, messageBarVM, editingEntity]);

    const handClose = useCallback(() => {
        counterCustomerChargeVM.onMoreClose();
    }, [counterCustomerChargeVM]);

    const adjTypeDropdownOptions = useMemo(() => {
        return [{
            dropdownLabel: AdjustmentTypePolicy.TEXT_CANCEL,
            tagLabel: AdjustmentTypePolicy.TEXT_CANCEL,
            value: AdjustmentTypePolicy.TEXT_CANCEL,
        }, {
            dropdownLabel: AdjustmentTypePolicy.TEXT_CANCEL_REBILL,
            tagLabel: AdjustmentTypePolicy.TEXT_CANCEL_REBILL,
            value: AdjustmentTypePolicy.TEXT_CANCEL_REBILL,
        }]
    }, []);

    const memoAdjustmentType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                errorMessage={allFormState ? allFormState["adjustmentType"] : ""}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={editingEntity.adjustmentType || ''}
                fieldValue={editingEntity.adjustmentType}
                fieldLabel={COUNTER_CUSTOMER_CHARGE_CONSTANT.ADJUSTMENT_TYPE}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'adjustmentType'}
                maxLength={60}
                sort={false}
                options={adjTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    counterCustomerChargeVM.onCounterCustomerFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, editingEntity.adjustmentType, COUNTER_CUSTOMER_CHARGE_CONSTANT.ADJUSTMENT_TYPE, adjTypeDropdownOptions, counterCustomerChargeVM])


    return (<div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 0px" }}>
        <div className={'flex-row'}>
            <div className={'flex-row-item flex-row-item-full-width'}>
                <Sidebarheader>
                    <HeaderTitle>{"Adjustment"}</HeaderTitle>
                </Sidebarheader>
            </div>
        </div>

        {isLoading && <Loader Indicator="Spinner" size="Medium" />}

        <div className={'add-edit-form'} style={{ maxHeight: '75vh', height: '75vh', overflow: 'auto' }}>
            <div className="flex-row-auto">
                <div className={'flex-row-item'}>
                    {memoAdjustmentType}
                </div>
            </div>
        </div>
        <SidebarActionBar>
            <HPHButton label={'Close'} size={'Small'} theme={'Secondary'} onClick={handClose} />
            <HPHButton label={'Save'} size={'Small'} theme={'Primary'} onClick={() => handleSaveClick()} />
        </SidebarActionBar>
    </div>)
}

export default memo(AdjustmentPanel);